"use client";

import Form, { StringInput, EmailInput } from "@/components/forms";
import { NewsletterJoinForm as schema } from "@/types";

type Props = {}

export const NewsletterJoinForm: React.FC<Props> = ({ }) => {
    return (
        <Form code="newsletter:join" schema={schema} title="Get the latest insights and tips" description="Join our newsletter for the latest insights on Telephony Voice AI Agents, technology, and business growth." buttonName="Join">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <StringInput name="firstName" label="What is your first name?" description="required" placeholder="e.g. John" />
                <StringInput name="lastName" label="What is your last name?" description="required" placeholder="e.g. Doe" />
                <EmailInput name="email" label="What is your email address?" description="required" placeholder="e.g. john.doe@example.com" />
                <StringInput name="company" label="What is your company's name?" description="optional" placeholder="e.g. Acme Inc." />
            </div>
        </Form>
    );
}